import React, { useState } from 'react';
import { getFieldValue, getAssetUrl, extractRichTextFromFields, renderRichText } from '../../../contentful/mappers';
import './ImagePanels.css';

function ImagePanels({ data }) {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!data) return null;

  const panels = getFieldValue(data, 'panels') || [];
  const headline = getFieldValue(data, 'headline');

  const handlePanelClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handlePanelHover = (index) => {
    setActiveIndex(index);
  };

  const handlePanelLeave = () => {
    setActiveIndex(null);
  };

  const getImageUrl = (panel) => {
    if (!panel || !panel.fields || !panel.fields.image) {
      return null;
    }
    
    const imageField = panel.fields.image;
    
    if (typeof imageField === 'object' && imageField !== null && !Array.isArray(imageField)) {
      if (imageField['en-US'] && imageField['en-US'].fields) {
        return getAssetUrl(imageField['en-US']);
      } 
      else if (imageField.fields && imageField.fields.file) {
        return getAssetUrl(imageField);
      }
      else {
        const localeKeys = Object.keys(imageField).filter(key => {
          const value = imageField[key];
          return value && typeof value === 'object' && value.fields && value.fields.file;
        });
        if (localeKeys.length > 0) {
          return getAssetUrl(imageField[localeKeys[0]]);
        }
      }
    } 
    else if (imageField && imageField.fields && imageField.fields.file) {
      return getAssetUrl(imageField);
    }
    
    return null;
  };

  return (
    <section className="image-panels-section">
      <div className="container">
        {headline && <h1 className="image-panels-headline">{headline}</h1>}
        <div className="image-panels-container">
          {panels.map((panel, index) => {
            const panelHeadline = getFieldValue(panel, 'headline');
            const description = extractRichTextFromFields(panel, 'description');
            const imageUrl = getImageUrl(panel);
            const isActive = activeIndex === index;

            return (
              <div
                key={panel.sys?.id || index}
                className={`image-panel ${isActive ? 'image-panel-active' : ''}`}
                onClick={() => handlePanelClick(index)}
                onMouseEnter={() => handlePanelHover(index)}
                onMouseLeave={handlePanelLeave}
              >
                {imageUrl && (
                  <div className="image-panel-background">
                    <img src={imageUrl} alt={panelHeadline || 'Panel image'} />
                    <div className={`image-panel-overlay ${isActive ? 'image-panel-overlay-active' : ''}`}></div>
                  </div>
                )}
                <div className="image-panel-content">
                  {panelHeadline && (
                    <h2 className={`image-panel-headline ${isActive ? 'image-panel-headline-active' : ''}`}>
                      {panelHeadline}
                    </h2>
                  )}
                  {isActive && description && (
                    <div className="image-panel-description">
                      {renderRichText(description)}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ImagePanels;
